import axios from 'axios';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { hydrateLtiSessionFromHash } from './Auth/hydrateLtiSession';
import './index.css';

// Must run before any Amplify/React code so validateSession() finds the tokens.
hydrateLtiSessionFromHash();
// import reportWebVitals from './reportWebVitals';

declare global {
  interface Window {
    env: Record<string, string>;
  }
}

let envExtension: Record<string, string>;
axios('/environment.json')
  .then((env) => {
    console.log(
      `environment.json loaded: ${JSON.stringify(env.data, null, 2)}`,
    );
    envExtension = env.data;
    console.debug(process.env);
  })
  .catch((ex) => {
    console.warn(`Couldn't load environment.json: ${ex.response?.status}`);
  })
  .finally(async () => {
    const rootElement = document.getElementById('root');

    if (!rootElement) {
      throw new Error('Root element not found');
    }

    const root = ReactDOM.createRoot(rootElement);
    window.env = {
      REACT_APP_PLATFORM: process.env.REACT_APP_PLATFORM,
      REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
      REACT_APP_VERSION: process.env.REACT_APP_VERSION,
      REACT_APP_REGION: process.env.REACT_APP_REGION,
      REACT_APP_USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
      REACT_APP_USER_POOL_CLIENT_ID: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      REACT_APP_USER_POOL_DOMAIN: process.env.REACT_APP_USER_POOL_DOMAIN,
      REACT_APP_MEDIA_BASE_URL: process.env.REACT_APP_MEDIA_BASE_URL,
      REACT_APP_API_URL: process.env.REACT_APP_API_URL,
      REACT_APP_LOGROCKET_APP_ID: process.env.REACT_APP_LOGROCKET_APP_ID,
      REACT_APP_MIXPANEL_PROJECT_TOKEN:
        process.env.REACT_APP_MIXPANEL_PROJECT_TOKEN,
      REACT_APP_SURVICATE_WORKSPACE_KEY:
        process.env.REACT_APP_SURVICATE_WORKSPACE_KEY,
      REACT_APP_SURVICATE_FEEDBACK_SURVEY_ID:
        process.env.REACT_APP_SURVICATE_FEEDBACK_SURVEY_ID,
      REACT_APP_SURVICATE_STORY_FEEDBACK_SURVEY_ID:
        process.env.REACT_APP_SURVICATE_STORY_FEEDBACK_SURVEY_ID,
      REACT_APP_SURVICATE_BOOK_FEEDBACK_SURVEY_ID:
        process.env.REACT_APP_SURVICATE_BOOK_FEEDBACK_SURVEY_ID,
      REACT_APP_SURVICATE_BOOK_VIDEO_FEEDBACK_SURVEY_ID:
        process.env.REACT_APP_SURVICATE_BOOK_VIDEO_FEEDBACK_SURVEY_ID,

      REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
      REACT_APP_SHARED_MEDIA_BASE_URL:
        process.env.REACT_APP_SHARED_MEDIA_BASE_URL,
      REACT_APP_DEFAULT_TIMEZONE: process.env.REACT_APP_DEFAULT_TIMEZONE,
      REACT_APP_TIMEBACK_STORE_BASE_URL:
        process.env.REACT_APP_TIMEBACK_STORE_BASE_URL,
      ...(envExtension || {}),
    };

    // We use inline import, so that App is only initialized when env vars are available
    // That helps us to not be concerned with knowing whether env vars are there or not, and use them anywhere
    const App = (await import('./App')).default;

    root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>,
    );
  });
